import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M11.977 17.517H11.976C11.711 17.517 11.457 17.41 11.271 17.22L2.38303 8.16705C2.00003 7.77705 2.00603 7.15005 2.39603 6.76705C2.78603 6.38405 3.41203 6.39005 3.79603 6.78005L11.98 15.116L20.207 6.77805C20.591 6.38805 21.219 6.38505 21.607 6.76805C21.997 7.15205 22 7.77905 21.617 8.16805L12.683 17.222C12.496 17.411 12.242 17.517 11.977 17.517V17.517Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ChevronDown');

export default Icon;
